<mat-slide-toggle [color]="color" [labelPosition]="labelPosition" [formControl]="control">
    <ng-content></ng-content>
</mat-slide-toggle>
